import { styled } from "@linaria/react"


import { Centered } from "@/components/Centered/Centered.ts"
import { AgentMessageContainer } from "@/components/Chat/AgentMessageStyles.ts"
import { creditsToDollars, formatDollars } from "@/lib/displayUtils.ts"
import { smallFontSize } from "@/styles/textStyles.ts"

import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"


export const CreditsSpentMessage = ({ content, isActive }: {
  content: AiChatMessageContent.CreditsSpent
  isActive: boolean
}) => {
  const { creditsSpent, totalCreditsSpent } = content
  const dollarsSpent = creditsToDollars(creditsSpent)
  const totalDollarsSpent = creditsToDollars(totalCreditsSpent)

  const formattedDollarsSpent = formatDollars(dollarsSpent)
  const formattedTotalDollarsSpent = formatDollars(totalDollarsSpent)

  return (
    <AgentMessageContainer isActive={isActive}>
      <Centered>
        <PillContainer>
          {`Spent: $${formattedDollarsSpent}, total: $${formattedTotalDollarsSpent}`}
        </PillContainer>
      </Centered>
    </AgentMessageContainer>
  )
}

const PillContainer = styled.span`
  ${smallFontSize};
  color: var(--secondary-text-color);
  text-align: center;

  padding: 0 16px;
  border-radius: var(--border-radius-8);
`